import { injectable } from "tsyringe";
import { CreateBookingV3ApiRepository } from "@/app/infrastructures/repositories/api/CreateBookingV3ApiRepository";

@injectable()
export class CreateBookingV3Presenter {
  private repository: CreateBookingV3ApiRepository;

  constructor(repository: CreateBookingV3ApiRepository) {
    this.repository = repository;
  }
}
